import {
    getAuth,
    GoogleAuthProvider,
    onAuthStateChanged,
    signInWithPopup,
    signOut
} from "firebase/auth";
import * as Sentry from "@sentry/browser";
import {fetch} from "./tt-req";

export class TTAuthApi {

    static get(firebaseApp) {

        if ("fake" === AUTH_PROVIDER) {
            console.log("Using fake auth provider")
            return new FakeAuthApi()
        }

        if ("firebase" === AUTH_PROVIDER) {
            console.log("Using firebase auth provider")
            return new FirebaseAuthApi(firebaseApp)
        }

    }

}

class FakeAuthApi {

    onAuthStateChanged = (user) => {
    }

    /* keep for test */
    fakeUser() {
        console.log("Injecting fake user")
        this.onAuthStateChanged(
            {
                photoURL: "https://via.placeholder.com/50",
                displayName: "Testuser",
                getIdToken: function () {
                    return Promise.resolve("fake-token")
                }
            }
        )
    }

    login() {
        this.fakeUser()
    }

    logout() {
        this.onAuthStateChanged(null)
    }

}

class FirebaseAuthApi {

    onAuthStateChanged = (user) => {
    }

    constructor(firebaseApp) {
        this.auth = getAuth(firebaseApp);
        onAuthStateChanged(this.auth, user => {
            this.onAuthStateChanged(user)
        });
    }

    login() {
        let provider = new GoogleAuthProvider();
        signInWithPopup(this.auth, provider)
            .then(resp => this._sendUserToBackend(resp.user))
            .catch(this._handleLoginError);
    }

    _sendUserToBackend(user) {
        console.log("Creating user in backend");
        fetch(user, `/api/users`, {
            method: "PUT"
        });
    }

    _handleLoginError(e) {
        if (e && e.code && e.code === "auth/popup-closed-by-user") return

        Sentry.captureException(e);
    }

    logout() {
        signOut(this.auth).then(() => {
            console.log("Signed out!");
        }, (e) => {
            Sentry.captureException(e);
        });
    }

}